import { heroStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section
      id="top"
      className="relative pt-28 md:pt-36 pb-14 md:pb-20 px-4 md:px-8 bg-gradient-to-b from-background-100 via-background-50 to-background-50"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium">
            <i className="ri-user-forbid-line text-base"></i>
            <span>匿名投稿 · 无需实名 · 审核后展示</span>
          </span>

          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
            匿名投稿与曝光线索，
            <br className="hidden sm:block" />
            交给<span className="text-primary-600">黑料社区</span>来承接
          </h2>

          <p className="mt-5 text-base md:text-lg leading-relaxed text-foreground-600 max-w-2xl">
            私信投稿，或直接把线索提交到曝光台。不用暴露身份就能发布爆料内容，投稿后由社区审核展示，
            保护爆料人安全，让每一条线索都有机会被看见。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#submit"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill"></i>
              <span>立即匿名投稿</span>
            </a>
            <a
              href="#flow"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300 bg-background-50 text-foreground-800 text-sm md:text-base font-medium hover:border-secondary-400 hover:text-secondary-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-flow-chart"></i>
              <span>了解审核机制</span>
            </a>
          </div>

          <dl className="mt-10 grid grid-cols-3 gap-4 md:gap-8 max-w-2xl">
            {heroStats.map((stat) => (
              <div key={stat.id} className="border-l-2 border-primary-300 pl-3 md:pl-4">
                <dt className="text-xs md:text-sm text-foreground-500">{stat.label}</dt>
                <dd className="mt-1 font-heading text-xl md:text-3xl font-bold text-foreground-950">
                  {stat.value}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5 relative animate-fade-up">
          <div className="relative w-full h-[320px] sm:h-[400px] lg:h-[480px] rounded-lg overflow-hidden bg-accent-100">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20illustration%20symbolizing%20anonymous%20tip%20submission%2C%20a%20closed%20envelope%20with%20a%20wax%20seal%20beside%20a%20small%20padlock%2C%20warm%20crimson%20and%20amber%20accents%20over%20a%20soft%20cream%20paper%20background%2C%20geometric%20minimal%20shapes%2C%20subtle%20paper%20grain%20texture%2C%20generous%20negative%20space%2C%20flat%20vector%20art%20style%2C%20high%20detail%2C%20harmonious%20balanced%20composition&width=900&height=1080&seq=heiliao-hero-visual&orientation=portrait"
              alt="黑料社区匿名投稿通道示意插画"
              title="黑料社区匿名投稿 匿名爆料"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="absolute -bottom-5 left-4 md:left-6 right-4 md:right-auto md:w-72 bg-background-50 rounded-lg border border-background-200 p-4">
            <div className="flex items-center gap-2 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-base text-secondary-600"></i>
              <span>隐私保护已开启</span>
            </div>
            <p className="mt-2 font-heading text-sm font-semibold text-foreground-950">
              投稿信息默认脱敏后再进入审核队列
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}